var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './CustomButton.scss';
import clsx from 'clsx';
import { Button } from 'antd';
var CustomButton = function (props) {
    var children = props.children, onClick = props.onClick, iconSrc = props.iconSrc, _a = props.selected, selected = _a === void 0 ? false : _a, _b = props.className, className = _b === void 0 ? '' : _b, _c = props.hidden, hidden = _c === void 0 ? false : _c, _d = props.reference, reference = _d === void 0 ? undefined : _d, _e = props.small, small = _e === void 0 ? false : _e, _f = props.disabled, disabled = _f === void 0 ? false : _f;
    var handleClick = function (e) {
        if (onClick) {
            onClick(e);
        }
    };
    var classes = {
        button: clsx('button', selected && 'button--selected', hidden && 'button--hidden', small && 'button--small'),
        buttonDisabled: clsx('', disabled && ' button--disabled ')
    };
    return (_jsxs(Button, __assign({ className: classes.button + classes.buttonDisabled + className, onClick: handleClick, ref: reference, disabled: disabled }, { children: [iconSrc && _jsx("img", { src: "".concat(iconSrc), alt: iconSrc }), children] })));
};
export default CustomButton;
